import { getAjax, postAjax, getUCAjax, getBKAjax,postUCAjax } from './http'
import { urlSearchObj } from "@/utils/util.js";

// /api/order/can-order-devicelist 获取可预约的设备列表
export const getCanOrderDevList = async function (data) {
    return await getAjax('api/order/can-order-devicelist', data)
}

// api/panel/navigationList  获取首页信息
export const navigationList = async function (data) {
    if (!data) data = new Object;
    return await getAjax('api/panel/navigationList', data)
}

// /api/panel/advertList   首页-滚动图片广告
export const advertList = async function (data) {
    if (!data) data = new Object;
    data['section_id'] = '1'
    return await getAjax('api/panel/advertList', data)
}

// 我的预约详情
export const myorderdetail = async function (data) {
    if (!data) data = new Object;
    return await getAjax('api/order/myorderdetail', data)
}

// /api/tweet/list?page=1&pagesize=2  推文
export const tweetList = async function (data) {
    if (!data) data = new Object;
    return await getAjax('api/tweet/list', data)
}

// api/live/list  直播-列表
export const liveList = async function (data) {
    if (!data) data = new Object;
    data['page'] = 1
    data['pagesize'] = 10
    return await getAjax('api/live/list', data)
}

// 获取我的信息  /api/order/myorderlist
export const myorderlist = async function (data) {
    return await getAjax('api/order/myorderlist', data)
}

// /api/order/device-ordercfg
// 某一个设备的预约配置
export const getDeviceOrderCfg = async function (data) {
    return await getAjax('api/order/device-ordercfg', data)
}

// /api/order/device-ordercfg-map
export const getDeviceOrderCfgMap = async function (data) {
    return await getAjax('api/order/device-ordercfg-map', data)
}


// /api/order/ordering  用户预约时间
export const order = async function (data) {
    return await postAjax('api/order/ordering', data)
}

// 用户登录
export const login = async function (data) {
    if (!data) data = new Object;
    return await postAjax('login', data)
}

// 绑定用户姓名
export const reName = async function (data) {
    return await postAjax('api/rename', data)
}

// /api/order/preend  提前结束
export const preend = async function (data) {
    return await postAjax('api/order/preend', data)
}

// /api/order/expend-endtime
export const expendEndtime = async function (data) {
    return await postAjax('api/order/expend-endtime', data)
}

// /register 注册回调   废弃
export const register = async function (data) {
    if (!data) data = new Object;
    return await postAjax('register', data)
}

//  api/live/notice  直播预告
export const liveNotice = async function (data) {
    return await getAjax('api/live/notice', data)
}

// 取消预约 /api/order/cancel
export const cancel = async function (data) {
    return await postAjax('api/order/cancel', data)
}

// 获取图形验证码 uc/vccaptcha
export const vccaptcha = async function (data) {
    if (!data) data = new Object;
    data['instanceId'] = urlSearchObj().id ? urlSearchObj().id : ''
    // data['instanceId'] = 2261
    return await getUCAjax('uc/vccaptcha', data)
}

// 修改手机号 changePassword
export const changePassword =async function (data) {
    if (!data) data = new Object;
    data['productId'] = '5'
    let insId = urlSearchObj().id
    data['instanceIdCheck'] = insId
    data['instanceId'] = insId
    return await getUCAjax('uc/changePassword', data)
}

export const changePasswordOnly =async function (data) {
    if (!data) data = new Object;
    data['productId'] = '5'
    let insId = urlSearchObj().id
    data['instanceIdCheck'] = insId
    data['instanceId'] = insId
    data['phoneCode'] = '86'
    return await postUCAjax('uc/changePasswordOnly', data)
}

// 检测登录信息
export const checkLogin = async function (data) {
    if (!data) data = new Object;
    return await getUCAjax('uc/checkLogin', data)
}

// 切换用户账号机构绑定 uc/reBindingOrg
export const reBindingOrg = async function (data) {
    if (!data) data = new Object;
    data['productId'] = 5
    return await getUCAjax('uc/reBindingOrg', data)
}

// 绑定姓名
export const resetUserInfo = async function (data) {
    if (!data) data = new Object;
    return await getUCAjax('uc/resetUserInfo', data)
}

// 发送验证码
export const vcsend = async function (data) {
    if (!data) data = new Object;
    data['appid'] = 'bookan'
    return await getUCAjax('uc/vcsend', data)
}

// 注册第一步 registerStep1
export const registerStep1 = async function (data) {
    if (!data) data = new Object;
    return await getUCAjax('uc/registerStep1', data)
}

// 注册第一步 registerStep2
export const registerStep2 = async function (data) {
    if (!data) data = new Object;
    return await getUCAjax('uc/registerStep2', data)
}

// 获取实例信息 org/specialWebMain
export const insInfo = async function (data) {
    if (!data) data = new Object;
    data['instanceId'] = urlSearchObj().id ? urlSearchObj().id : ''
    // data['instanceId'] = 2261
    data['types'] = 'instanceInfo'
    return await getBKAjax('org/specialWebMain', data)
}


